const truthy = new Set(['1', 'true', 'yes', 'on']);

// Dev-only page to compare the legacy canvas chart vs the new visx chart.
// Off by default; enable with VITE_CHART_COMPARISON=true for local testing.
export const IS_CHART_COMPARISON_ENABLED = truthy.has(
    String(import.meta.env.VITE_CHART_COMPARISON ?? '').toLowerCase()
);
